/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Select, Typography } from "antd";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const { Text } = Typography;

const data = [
  { name: "5 Nov", amount: 3800 },
  { name: "7 Nov", amount: 3600 },
  { name: "8 Nov", amount: 4300 },
  { name: "9 Nov", amount: 1500 },
  { name: "10 Nov", amount: 3300 },
  { name: "11 Nov", amount: 2600 },
  { name: "12 Nov", amount: 1800 },
];

const CustomTooltip = ({
  active,
  payload,
}: {
  active?: boolean;
  payload?: any[];
}) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-2 shadow-md rounded border border-slate-100">
        <Text className="text-sm font-bold text-theme-slate-800">
          {payload[0].value.toLocaleString()}
        </Text>
      </div>
    );
  }
  return null;
};

export default function RevenueOverviewChart() {
  return (
    <Card
      className="shadow-sm bordered-card custom-card"
      title={
        <span className="text-theme-slate-800 text-lg font-medium">
          Revenue Overview
        </span>
      }
      extra={
        <Select
          defaultValue="7days"
          size="small"
          className="w-32"
          options={[{ label: "Last 7 days", value: "7days" }]}
        />
      }
    >
      <div className="h-80 w-full mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barSize={20}>
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#E2E8F0"
            />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#64748B", fontSize: 12 }}
              dy={10}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#64748B", fontSize: 12 }}
              tickFormatter={(value) => `৳${value}`}
            />
            <Tooltip
              content={<CustomTooltip />}
              cursor={{ fill: "transparent" }}
            />
            <Bar dataKey="amount" radius={[4, 4, 0, 0]}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.name === "9 Nov" ? "#FC8415" : "#CBD5E1"} // Highlight 9 Nov as per design
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
